<template>
	<div class="operate-stat-container">
		<el-tabs v-model="activeTab" class="mt20" @tab-change="handleTabChange">
			<div class="total-info" v-if="classStatResult&&activeTab=='classStat'">
				<span>模拟学生：{{ classStatResult.operateStudentTotal }} 人</span>
				<span style="margin-left:30px;">模拟总次数：{{ classStatResult.allOperateTotalCount }} 次</span>
			</div>
			<el-tab-pane label="全班分析" name="classStat">
				<el-table :data="classStatList" border v-loading="classLoading" style="width:100%;margin-top:10px"
					empty-text="暂无学生操作数据">
					<el-table-column label="姓名" prop="studentName" align="center" />
					<el-table-column label="总操作次数" prop="totalOperateCount" align="center" />
					<el-table-column label="模拟次数" prop="htmlIndexOneCount" align="center" />
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="思考过程分析" name="stepDetail">
				<!-- 顶部饼图区域 -->
				<div class="chart-card">
					<h3 class="chart-title">学生思考分布统计</h3>
					<div id="layerPieChart" style="width:100%;height:300px;"></div>
				</div>
				<!-- 下方左右分栏表格 -->
				<div class="table-row">
					<div class="table-col">
						<h4 class="sub-title">思考分布</h4>
						<el-table :data="layerRawData.layerRuleList" border stripe v-loading="layerLoading" style="width:100%" empty-text="暂无分层数据">
							<el-table-column label="分层ID" prop="layerRuleId" align="center" width="120"/>
							<el-table-column label="分层名称" prop="layerName" align="center"/>
							<el-table-column label="触发次数" prop="studentNum" align="center" width="130">
								<template slot-scope="scope">
									<el-tag type="primary" size="small">{{ scope.row.operateCount }}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="学生明细" align="left">
								<template slot-scope="scope">
									<div class="student-name-wrap">
										<span
											v-for="sItem in scope.row.studentList"
											:key="sItem.studentId"
											class="flow-tag"
										>
											{{ sItem.studentName }}
											<span class="oper-index-badge" v-if="sItem.operateCount != null">{{ sItem.operateCount }}</span>
										</span>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="table-col">
						<h4 class="sub-title">学生思考过程</h4>
						<el-table :data="layerRawData.studentList" border stripe v-loading="layerLoading" style="width:100%" empty-text="暂无学生分层数据">
							<el-table-column label="学生ID" prop="studentId" align="center" width="100"/>
							<el-table-column label="学生姓名" prop="studentName" align="center" width="110"/>
							<el-table-column label="分层流转顺序" align="left">
								<template slot-scope="scope">
									<div class="flow-wrap">
										<span v-for="(item,idx) in scope.row.layerList" :key="idx" >
											<span class="flow-tag" title="分层名称">
												{{ item.layerName }}
												<span class="oper-index-badge" :title="`第${item.roundNo}次模拟`">{{ item.roundNo }}</span>

											</span>
											<span v-if="idx < scope.row.layerList.length -1" class="arrow">→</span>
										</span>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
export default {
	name: "OperateStatPage",
	props: {
		courseClassId: {
			type: String,
			default: ''
		},
		srcUrl: {
			type: String,
			default: ''
		},
		htmlId: {
			type: Number,
			default:null
		},
		studentId: {
			type: [String, Number],
			default: ''
		},
	},
	data() {
		return {
			// 默认tab：全班分析
			activeTab: "classStat",

			// 全班分析
			classLoading: false,
			classStatResult: null,
			classStatList: [],
			// 步骤明细分析
			stepLoading: false,
			stepRecordList: [],

			// ============分层分析新增变量============
			layerLoading: false,
			layerRawData: {}, //接口原始arr数据
			layerTableData: [], //左侧分层表格
			studentTableData: [], //右侧学生时序表格
			pieChart: null
		};
	},
	created() {
		this.queryData()
	},
	methods: {
		//查询分层方法统计
		async getLayerLists(){
			this.layerLoading = true
			try{
				let res=await this.API.get(this.API.school.getLayerList,{
					 "courseClassId":this.courseClassId,
					  "htmlId": this.htmlId,
					  "schoolId": localStorage.getItem('orgId')
				})
				console.log('数据',res.data)
				let arr={"layerList":[],"layStudent":[]}
				// res?.data?.map(v=>{
				// 	let studentList=this.forStudent(v)
				// 	if(arr.layerList.find(_v=>_v.layerRuleId==v.layerRuleId)){
				// 		arr.layerList.find(_v=>_v.layerRuleId==v.layerRuleId).studentList.push(...studentList)
				// 	}else{
				// 		arr.layerList.push({
				// 			layerRuleId:v.layerRuleId,
				// 			layerName:v.layerName,
				// 			studentList:studentList
				// 		})
				// 	}
				// 	let layerList=this.layerList(v)
				// 	if(arr.layStudent.find(_v=>_v.studentId==v.studentId)){
				// 		arr.layStudent.find(_v=>_v.studentId==v.studentId).layerList.push(...layerList)
				// 	}else{
				// 		arr.layStudent.push({
				// 			studentId:v.studentId,
				// 			studentName:v.studentName,
				// 			layerList:layerList
				// 		})
				// 	}
				// })
				// arr.layerList=arr.layerList?.map(v=>{
				// 	v.studentList=v.studentList?.sort((a,b)=>a.lastTimestamp-b.lastTimestamp)
				// 	return {
				// 		...v
				// 	}
				// })
				// arr.layStudent=arr.layStudent?.map(v=>{
				// 	v.layerList=v.layerList?.sort((a,b)=>a.lastTimestamp-b.lastTimestamp)
				// 	return {
				// 		...v
				// 	}
				// })
				this.layerRawData=res.data
				this.layerRawData.studentList=res.data.studentList?.map(v=>{
					v.layerList=v.layerList?.sort((a,b)=>a.timestamp-b.timestamp)
					return {
						...v
					}
				})
				console.log('this.layerRawData.studentList',this.layerRawData.studentList)
				// this.layerRawData = arr
				// 格式化表格数据
				// this.formatLayerTable()
				// 渲染饼图
				this.$nextTick(()=>this.renderPieChart())
				console.log('arr',arr)
			}catch(err){
				this.$message.error("分层数据查询失败")
			}finally{
				this.layerLoading = false
			}
		},
		//格式化分层表格数据
		formatLayerTable(){
			const arr = this.layerRawData
			//左侧分层表格
			this.layerTableData = arr.layerList.map(item=>{
				return {
					layerRuleId: item.layerRuleId,
					layerName: item.layerName,
					studentCount: item.studentList?.length || 0
				}
			})
			console.log('arr.layStudent',arr.layStudent)
			//右侧学生时序表格
			this.studentTableData = arr.layStudent.map(student=>{
				return {
					studentId: student.studentId,
					studentName: student.studentName,
					sortLayerList: student.layerList
				}
			})
			console.log('this.studentTableData',this.studentTableData)
		},
		//渲染饼图
		renderPieChart(){
			if(!this.layerRawData || !this.layerRawData.layerRuleList.length) return
			if(!this.pieChart){
				this.pieChart = this.$echarts.init(document.getElementById('layerPieChart'))
			}
			const pieData = this.layerRawData.layerRuleList.map(item=>{
				return {
					name: item.layerName,
					value: item.operateCount
				}
			})
			const option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b}: {c}次 ({d}%)'
				},
				legend: {
					bottom: 0
				},
				series: [
					{
						type: 'pie',
						radius: ['40%','70%'],
						data: pieData,
						itemStyle: {borderRadius:6},
						label: {show:true, position:'outside'}
					}
				]
			}
			this.pieChart.setOption(option)
		},
		forStudent(arr){
			let list=[]
			for(let i=0;i<arr.lastTimestampList.length;i++){
				list.push({
					studentId:arr.studentId,
					studentName:arr.studentName,
					lastTimestamp:arr.lastTimestampList[i]
				})
			}
			return list
		},
		layerList(arr){
			let list=[]
			for(let i=0;i<arr.lastTimestampList.length;i++){
				list.push({
					layerRuleId:arr.layerRuleId,
					layerName:arr.layerName,
					lastTimestamp:arr.lastTimestampList[i]
				})
			}
			return list
		},
		// 统一查询入口
		queryData() {
			if (this.activeTab === "classStat") {
				this.getClassStat();
			} else {
				this.getLayerLists()
				this.getStepDetail();
			}
		},
		// 2026-07-29 报告分析：兼容 statByClass 常见响应包裹，避免有记录但表格为空。
		getResponseData(res) {
			if (!res) return null
			if (res.data && res.data.data !== undefined) return res.data.data
			if (res.data !== undefined) return res.data
			return res
		},
		extractList(payload) {
			// 2026-07-29 响应列表提取：兼容 data/list/rows 等既有包装，不改变接口请求。
			let data = payload
			let guard = 0
			while (data && typeof data === 'object' && !Array.isArray(data) && data.data !== undefined && guard < 3) {
				const keys = Object.keys(data)
				if (keys.length > 3 || data.studentStatList || data.records || data.rows || data.list || data.content) break
				data = data.data
				guard += 1
			}
			if (Array.isArray(data)) return data
			if (!data || typeof data !== 'object') return []
			const listKeys = ['studentStatList', 'records', 'rows', 'list', 'content']
			for (const key of listKeys) {
				if (Array.isArray(data[key])) return data[key]
			}
			return []
		},
		pickNumber(...values) {
			// 2026-07-29 数值兜底：按字段优先级取第一个有效数字，防止 0 被空字段覆盖。
			for (const item of values) {
				const num = Number(item)
				if (!Number.isNaN(num) && item !== '' && item !== null && item !== undefined) return num
			}
			return 0
		},
		normalizeMsgType(value) {
			// 2026-07-29 回放类型标准化：后端按不含域名和查询参数的网页路径匹配操作记录。
			let msgType = String(value || '').trim()
			if (!msgType) return ''
			try {
				if (/^https?:\/\//i.test(msgType)) {
					msgType = new URL(msgType).pathname
				}
			} catch (e) {}
			return msgType.split('?')[0].replace(/^\/+/, '')
		},
		normalizeClassStatRow(row = {}) {
			const totalOperateCount = this.pickNumber(row.totalOperateCount, row.operateCount, row.allOperateCount, row.count)
			const htmlIndexOneCount = this.pickNumber(row.htmlIndexOneCount, row.htmlIndexCount, row.simulateCount, row.operateBatchCount, row.operateCount)
			return {
				...row,
				studentId: row.studentId || row.userId || row.id || '',
				studentName: row.studentName || row.nickName || row.name || row.userName || row.studentId || '-',
				totalOperateCount,
				htmlIndexOneCount
			}
		},
		groupOperateRowsByStudent(list = []) {
			// 2026-07-29 班级统计兜底：统计接口若返回操作明细，在前端按学生聚合为表格行。
			const map = {}
			list.forEach(row => {
				const studentId = row.studentId || row.userId || row.id || row.studentName || '-'
				if (!map[studentId]) {
					map[studentId] = {
						studentId,
						studentName: row.studentName || row.nickName || row.name || row.userName || studentId,
						totalOperateCount: 0,
						htmlIndexSet: new Set()
					}
				}
				map[studentId].totalOperateCount += 1
				if (row.htmlIndex !== undefined && row.htmlIndex !== null && row.htmlIndex !== '') {
					map[studentId].htmlIndexSet.add(row.htmlIndex)
				}
			})
			return Object.values(map).map(item => ({
				studentId: item.studentId,
				studentName: item.studentName,
				totalOperateCount: item.totalOperateCount,
				htmlIndexOneCount: item.htmlIndexSet.size || item.totalOperateCount
			}))
		},
		buildClassStatResult(data = {}, list = []) {
			const source = data && typeof data === 'object' && !Array.isArray(data) ? data : {}
			const allOperateTotalCount = list.reduce((sum, item) => sum + this.pickNumber(item.totalOperateCount), 0)
			const operateStudentTotal = list.filter(item => this.pickNumber(item.totalOperateCount) > 0).length
			return {
				...source,
				// 2026-07-29 buildClassStatResult: 明细已有操作时以前端汇总兜底，避免后端摘要返回 0 覆盖真实记录。
				operateStudentTotal: operateStudentTotal || this.pickNumber(source.operateStudentTotal, source.studentTotal, source.operateStudentCount, 0),
				allOperateTotalCount: allOperateTotalCount || this.pickNumber(source.allOperateTotalCount, source.totalOperateCount, source.operateTotalCount, 0)
			}
		},
		// 1、全班分析接口 statByClass
		async getClassStat() {
			// 2026-07-29 全班报告：优先显示接口摘要；若只有明细，则仅在当前页面做只读汇总。
			if (!this.courseClassId || !this.srcUrl) return
			this.classLoading = true;
			const params = {
				schoolId: localStorage.getItem('orgId'),
				courseClassId: this.courseClassId,
				msgType: this.normalizeMsgType(this.srcUrl)
			};
			try {
				const res = await this.API.get(this.API.school.getHtmlStatByClass, params);
				console.log('班级统计：', res)
				if (res.status === 200) {
					const data = this.getResponseData(res) || {}
					let list = this.extractList(data)
					const isOperateRows = list.some(item => item && (item.funcName || item.operateTimestamp || item.triggerElement))
					const hasStatRows = list.some(item => item && (item.totalOperateCount !== undefined || item.htmlIndexOneCount !== undefined || item.operateCount !== undefined))
					if (isOperateRows && !hasStatRows) {
						list = this.groupOperateRowsByStudent(list)
					} else {
						list = list.map(item => this.normalizeClassStatRow(item))
					}
					this.classStatList = list;
					this.classStatResult = this.buildClassStatResult(data, list);
				} else {
					this.$message.error(res.data.msg || "查询班级统计失败");
				}
			} catch (err) {
				this.$message.error("网络异常，查询失败");
			} finally {
				this.classLoading = false;
			}
		},
		// 2、步骤明细回放接口 listForPlayback
		async getStepDetail() {
			// 2026-07-29 个人步骤：调用已有回放接口，不再错误复用全班统计接口。
			if (!this.courseClassId || !this.studentId || !this.srcUrl) {
				this.stepRecordList = []
				return
			}
			this.stepLoading = true;
			const params = {
				schoolId: localStorage.getItem('orgId'),
				courseClassId: this.courseClassId,
				studentId: this.studentId,
				msgType: this.normalizeMsgType(this.srcUrl)
			};
			try {
				const res = await this.API.get(this.API.school.getlistForPlayback, params);
				const code = res && res.data ? res.data.code : undefined
				if (res && res.status === 200 && (code === undefined || Number(code) === 200 || Number(code) === 0)) {
					// 2026-07-29 getStepDetail: 复用现有回放接口，统一响应结构后再渲染步骤表。
					this.stepRecordList = this.extractList(this.getResponseData(res)).map((item, index) => ({
						...item,
						operateSeq: item.operateSeq || item.sequence || index + 1,
						msgType: item.msgType || params.msgType,
						funcName: item.funcName || item.operateName || item.name || '-',
						operateTimestamp: item.operateTimestamp || item.timestamp || item.createTime || '-'
					}));
				} else {
					this.$message.error((res && res.data && res.data.msg) || "查询步骤明细失败");
				}
			} catch (err) {
				this.$message.error("网络异常，查询失败");
			} finally {
				this.stepLoading = false;
			}
		},

		// tab切换清空表格
		handleTabChange() {
			//切换tab清空分层数据
			this.layerRawData = {}
			this.layerTableData = []
			this.studentTableData = []
			if(this.pieChart){
				this.pieChart.dispose()
				this.pieChart = null
			}
			this.classStatList = [];
			this.stepRecordList = [];
			this.classStatResult = null;
			this.queryData()
		}
	},
	watch: {
		activeTab() {
			this.handleTabChange();
		},
		srcUrl() {
			this.queryData();
		},
		courseClassId() {
			this.queryData();
		},
		studentId() {
			if (this.activeTab === 'stepDetail') this.queryData()
		}
	},
	mounted(){
		//窗口缩放重绘饼图
		window.addEventListener('resize',()=>{
			this.pieChart?.resize()
		})
	}
};
</script>

<style scoped>
	.search-card {
		margin-bottom: 15px;
	}

	.mt20 {
		margin-top: 20px;
	}

	.total-info {
		margin-top: 12px;
		font-size: 14px;
		color: #303133;
	}
	/* 分层分析样式 */
	.chart-card{
		background:#fff;
		padding:16px 20px;
		border-radius:6px;
		margin-bottom:16px;
		box-shadow: 0 1px 4px rgba(0,0,0,0.06);
	}
	.chart-title{
		margin:0 0 12px;
		font-size:16px;
		color:#333;
	}
	.table-row{
		display:flex;
		gap:16px;
	}
	.table-col{
		flex:1;
		background:#fff;
		padding:16px;
		border-radius:6px;
		box-shadow: 0 1px 4px rgba(0,0,0,0.06);
	}
	.sub-title{
		margin:0 0 12px;
		font-size:15px;
		color:#444;
	}
	.flow-wrap{
		display:flex;
		flex-wrap:wrap;
		align-items:center;
		gap:6px;
	}
	.flow-tag{
		background:#ecf5ff;
		color:#409EFF;
		padding:3px 9px;
		font-size:12px;
		border-radius:12px;
	}
	.arrow{
		color:#999;
	}
	.oper-index-badge {
	  display: inline-block;
	  min-width: 16px;
	  height:16px;
	  line-height:16px;
	  text-align:center;
	  font-size:10px;
	  background-color:#409EFF;
	  color:#fff;
	  border-radius:8px;
	  margin-left:5px;
	  padding:0 3px;
	}
	.student-name-wrap {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		padding:4px 0;
	}
</style>